import React from 'react';
import logo from '@/assets/Logo.png';

function Footer(): React.ReactElement {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 mt-auto">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-10 lg:gap-12 pb-12 border-b border-gray-800">
          {/* Brand Section */}
          <div className="max-w-[300px] sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img src={logo} alt="SocialSpark" className="w-9 h-9 object-contain" />
              <span className="font-display text-xl font-bold text-white">SocialSpark</span>
            </div>
            <p className="text-gray-400 text-[15px] leading-relaxed m-0">Empowering teams with better collaboration tools.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">Quick Links</h4>
            <ul className="list-none p-0 m-0 space-y-3">
              <li><a href="/engineering" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Engineering & Technology</a></li>
              <li><a href="/resources" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Resources</a></li>
              <li><a href="/documents" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Documents</a></li>
              <li><a href="/marketing" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Marketing</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">Resources</h4>
            <ul className="list-none p-0 m-0 space-y-3">
              <li><a href="#" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Brand Guidelines</a></li>
              <li><a href="#" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Content Analytics</a></li>
              <li><a href="#" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">Developer Docs</a></li>
              <li><a href="#" className="text-gray-400 text-[15px] no-underline transition-colors duration-150 hover:text-white">GTM Rollout Hub</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">Locations</h4>
            <ul className="list-none p-0 m-0 space-y-3 text-[15px] text-gray-400">
              <li>Hartford, CT (HQ)</li>
              <li>Tempe, AZ</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center py-6 gap-4 text-[13px]">
          <p className="m-0 text-gray-500">&copy; {currentYear} SocialSpark. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-500 no-underline transition-colors duration-150 hover:text-gray-300">Privacy Policy</a>
            <a href="#" className="text-gray-500 no-underline transition-colors duration-150 hover:text-gray-300">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
